import { Mediator } from '@spotahome/soyuz-mediator';
import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import Tag from '../Tag';
import PlusIcon from '../icons/PlusIcon';
import { DSIcon } from '../../../base';

import styles from './PlusValuePropositionModal.module.scss';

const OriginalLabel = () => (
  <Tag
    className={styles['plus-value-proposition-modal__tag']}
    label="Spotahome PLUS"
    colorSchema="blue"
    size="small"
    keepLabelCase
    renderLeadingIcon={() => (
      <PlusIcon
        size="normal"
        className={styles['plus-value-proposition-modal__tag-icon']}
      />
    )}
  />
);

const VariantLabel = () => (
  <span
    className={styles['plus-value-proposition-modal__header-label-with-icon']}
  >
    <DSIcon name="spoke" size="l" />
    Spotahome Plus
  </span>
);

const PlusValuePropositionModalTitle = () => {
  const isVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';
  return isVariant ? <VariantLabel /> : <OriginalLabel />;
};

const PlusValuePropositionModalContent = () => {
  const isVariant =
    useSoyuzExperiment('ListingSimplificationHeaderV2').get('behaviour') ===
    'variant';

  if (isVariant) {
    return (
      <>
        <p>{trans('plus.modal.description')}</p>

        <div>
          <h5
            className={
              styles['plus-value-proposition-modal__conditions-title']
            }
          >
            {trans('plus.modal.conditions1')}
          </h5>
          <ul
            className={
              styles['plus-value-proposition-modal__conditions-list']
            }
          >
            <li>{trans('plus.modal.conditions1.item1')}</li>
            <li>{trans('plus.modal.conditions1.item2')}</li>
            <li>{trans('plus.modal.conditions1.item3')}</li>
          </ul>
        </div>
      </>
    );
  }

  return (
    <>
      <h2 className={styles['plus-value-proposition-modal__body-title']}>
        <strong>{trans('plus.value.proposition.modal.title')}</strong>
      </h2>
      <ul>
        <li
          dangerouslySetInnerHTML={{
            __html: trans('plus.value.proposition.modal.point1')
          }}
        />
        <li
          dangerouslySetInnerHTML={{
            __html: trans('plus.value.proposition.modal.point2')
          }}
        />
      </ul>
    </>
  );
};

const openPlusValuePropositionModal = () => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: <PlusValuePropositionModalTitle />,
    body: <PlusValuePropositionModalContent />,
    fullscreenOnMobile: true
  });
};

export default openPlusValuePropositionModal;
